import React from 'react';

// Types
import { GoalItem, GoalMetricTypeType } from 'Shared/constants/types';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import GoalActionItemsProgress from '../GoalActionItemsProgress/GoalActionItemsProgress';
import GoalSubGoalProgress from '../GoalSubGoalProgress/GoalSubGoalProgress';
import GoalMetricValueProgress from '../GoalMetricValueProgress/GoalMetricValueProgress';

// Styles
import './GoalProgress.scss';

export type ViewType = 'table' | 'panel' | 'page';
type Props = {
  goal: GoalItem;
  showEmptyState?: boolean;
  inContainer?: boolean;
  view?: ViewType;
};

const GoalProgress = ({ goal, showEmptyState, inContainer = false, view = 'table' }: Props) => {
  const Content = () => {
    if (goal.metricType === GoalMetricTypeType.action_items)
      return <GoalActionItemsProgress goal={goal} showEmptyState={showEmptyState} view={view} />;
    if (goal.metricType === GoalMetricTypeType.sub_goals)
      return <GoalSubGoalProgress goal={goal} showEmptyState={showEmptyState} view={view} />;
    if (
      goal.metricType === GoalMetricTypeType.percent ||
      goal.metricType === GoalMetricTypeType.number ||
      goal.metricType === GoalMetricTypeType.dollar_amount
    )
      return <GoalMetricValueProgress goal={goal} view={view} />;
    return null;
  };

  const baseClassName = 'GoalProgress';
  if (inContainer) {
    return (
      <WpContainer className={`${baseClassName}__container`}>
        <WpContainerBody padding="05">
          <p className={`${baseClassName}__container__title`}>Goal Progress</p>
          <Content />
        </WpContainerBody>
      </WpContainer>
    );
  }

  return <Content />;
};

export default GoalProgress;
